import React from "react";
import "./styles.scss";
import classes from "./Slider.module.scss"
import { useTranslation } from "react-i18next";

export const Slide = React.memo(function (StackedCarouselSlideProps) {
    const { t } = useTranslation();
    const {
        data,
        dataIndex,
        isCenterSlide,
        swipeTo,
        slideIndex
    } = StackedCarouselSlideProps;

    const coverImage = data[dataIndex].image;
    const text = data[dataIndex].text;
    const name = data[dataIndex].name;
    const star = data[dataIndex].star;
    const colorStars = data[dataIndex].colorStars;

    return (
        <div className="card-card" draggable={false}>
            <div className={`cover fill ${isCenterSlide ? "off" : "on"}`}>
                <div
                    className="card-overlay fill"
                    onClick={() => {
                        if (!isCenterSlide) swipeTo(slideIndex);
                    }}
                />
            </div>
            <div style={{ width: '100%' }} className="detail fill">
                <div className="discription">
                    <div className={classes.slide}>
                        <div className={classes.slideTop}>
                            <div className={classes.slideTopLeft}>
                                <img src={coverImage} alt={name} />
                            </div>
                            <div className={classes.slideTopRight}>
                                <div className={classes.slideTopRightStars}>
                                    <div className={classes.slideTopRightStarsWrap}>
                                        <p className={classes.slideTopRightStarsName}>
                                            {name}
                                        </p>
                                        <div className={classes.tradersSliderSlideItemTopStars}>
                                            <div
                                                className={[ classes.tradersSliderSlideItemTopStarsProgress, colorStars].join(" ")}
                                                style={{ width: star + "%" }}
                                            ></div>
                                            <div className={classes.tradersSliderSlideItemTopStarsStar}></div>
                                            <div className={classes.tradersSliderSlideItemTopStarsStar}></div>
                                            <div className={classes.tradersSliderSlideItemTopStarsStar}></div>
                                            <div className={classes.tradersSliderSlideItemTopStarsStar}></div>
                                            <div className={classes.tradersSliderSlideItemTopStarsStar}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className={[classes.slideText, "font-20"].join(" ")}>
                            {t(text)}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Slide;